<template>
    <div class="member_breadcrumb">
        <i class="icon-home"></i>当前位置：个人中心 > {{title}}
    </div>
</template>

<script>    
    export default {
        data() {
            return {
                active_index: 0,
                title: ""
            };
        },
        watch:{
            $route: {
                handler: function(){
                    switch (this.$route.name) {
                        case 'memberIndex':
                            this.title = "修改密码";
                            break;
                        case 'memberRecharge':
                            this.title = "客服方式";
                            break;
                        case 'memberShare':
                            this.title = "分享赚钱";
                            break; 
                    }
                },
                immediate: true
            }
        }
    }
</script>

<style lang="scss">
    .member_breadcrumb {        
        height: 48px;
        display: flex;
        align-items: center;
        font-size: 14px;
        color: #88522a;
        background: #FAEADA;
        padding-left: 20px;
        box-sizing: border-box;
        border-bottom: 1px solid #DDA76B;
        .icon-home {
            background-repeat: no-repeat;
            background-position: center center;
            height: 20px;
            width: 20px;
            display: inline-block;
            background-image: url('../../assets/images/member/home.png');
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/member/breadcrumb.vue